import {
    SettlementVatRatesFormFields,
    SettlementVatRatesSettingsDto,
    VatReleaseReason,
} from 'types';

export const parseSettlementVatRatesSettingsDtoIntoSettlementVatRatesFormFields: (
    settlementVatRatesSettingsDto: SettlementVatRatesSettingsDto,
) => SettlementVatRatesFormFields = (settlementVatRatesSettingsDto) => {
    const {
        stayVatRateType,
        mealVatRateType,
        starterKitVatRateType,
        stayVatReleaseReason,
        mealVatReleaseReason,
        starterKitVatReleaseReason,
        mealCustomVatReleaseReason,
        stayCustomVatReleaseReason,
        starterKitCustomVatReleaseReason,
    } = settlementVatRatesSettingsDto;

    return {
        stayVatRateType,
        mealVatRateType,
        starterKitVatRateType,
        stayVatReleaseReason: stayVatReleaseReason || ('' as VatReleaseReason),
        mealVatReleaseReason: mealVatReleaseReason || ('' as VatReleaseReason),
        starterKitVatReleaseReason: starterKitVatReleaseReason || ('' as VatReleaseReason),
        mealCustomVatReleaseReason: mealCustomVatReleaseReason || '',
        stayCustomVatReleaseReason: stayCustomVatReleaseReason || '',
        starterKitCustomVatReleaseReason: starterKitCustomVatReleaseReason || '',
    };
};
